import { useEffect } from 'react'

export default function SlidesRedirect () {
  const URL =
    'https://docs.google.com/presentation/d/e/2PACX-1vTrornUCjKbArlfQXJvBWUTy47m1EUDocVx_L3RQt4ML_4vJRM_58i0mInKU9TRoQ-5DVuZZWAgWQoC/pub?start=false&loop=false&delayms=10000&slide=id.g34ed84e87a6_0_164'

  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'redirect', {
        event_category: 'Navigation',
        event_label: '/slides'
      })
    }

    const timer = setTimeout(() => {
      window.location.href = URL
    }, 100)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div style={{ padding: '80px', textAlign: 'center' }}>
        <h1>Redirecting to our slides 🚦</h1>
        <p>
          If you are not redirected automatically, <a href={URL}>click here</a>.
        </p>
      </div>
    </>
  )
}
